// AdminLogin.jsx

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './Question.css';
import './App.css';
import Navbar from './Navbar.js';
import { IoMdArrowBack } from "react-icons/io";
import { MdInfo, MdUpload, MdDownload, MdWarning } from "react-icons/md";
import { FaFileExcel, FaFileCsv, FaClipboardList } from "react-icons/fa";

function AdminLogin() {
    const navigate = useNavigate();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    const handleSubmit = (event) => {
        event.preventDefault();
        // Login functionality removed
    };

    return (
        <div className="container">
            <Navbar currentPage='PickupForm' />
            
            <div className="login-form-container" style={{ width: '800px', padding: '40px', maxHeight: '80vh', overflowY: 'auto' }}>
                <h1 style={{ textAlign: 'center', marginBottom: '30px', color: '#096D6F' }}>
                    <FaClipboardList style={{ marginRight: '10px', verticalAlign: 'middle' }} />
                    Airport Pickup Information
                </h1>
                
                <div style={{ marginBottom: '30px' }}>
                    <h2 style={{ color: '#096D6F', marginBottom: '15px' }}>
                        <MdUpload style={{ marginRight: '10px', verticalAlign: 'middle' }} />
                        New Upload Mobile Data Excel File Function
                    </h2>
                    <p style={{ marginBottom: '20px', lineHeight: '1.6' }}>
                        This new feature allows you to merge mobile data into the portal for easy visualization and data download. The system processes data based on Request numbers and manages status updates automatically.
                    </p>
                    
                    <h3 style={{ color: '#096D6F', marginBottom: '10px' }}>Process Steps:</h3>
                    <ol style={{ padding: '0 20px', textAlign: 'left', lineHeight: '1.8' }}>
                        <li style={{ marginBottom: '15px' }}>
                            <FaFileExcel style={{ marginRight: '8px', verticalAlign: 'middle', color: '#096D6F' }} />
                            <strong>Download Excel from Mobile Portal Management:</strong> The portal will compare data using the Request number and load all 'Confirm' data into the portal for processing.
                        </li>
                        <li style={{ marginBottom: '15px' }}>
                            <MdInfo style={{ marginRight: '8px', verticalAlign: 'middle', color: '#096D6F' }} />
                            <strong>Status Update Processing:</strong> The system will loop through all data and automatically update the status to 'Cancelled' in the database for any records that were originally confirmed but have since been cancelled. All data processing is based on the information you provide to the portal.
                        </li>
                        <li style={{ marginBottom: '15px' }}>
                            <MdDownload style={{ marginRight: '8px', verticalAlign: 'middle', color: '#096D6F' }} />
                            <strong>Driver Download Options:</strong> After processing, drivers can download the driver slip and CSV file containing the merged data from both mobile and web portal sources. The driver slip will include mobile data but will not display information about the data source.
                        </li>
                    </ol>
                </div>

                <div style={{ marginTop: '30px' }}>
                    <h2 style={{ color: '#096D6F', marginBottom: '15px' }}>
                        <MdWarning style={{ marginRight: '10px', verticalAlign: 'middle' }} />
                        Important Information
                    </h2>
                    <ul style={{ padding: '0 20px', textAlign: 'left', lineHeight: '1.6' }}>
                        <li style={{ marginBottom: '10px' }}>
                            <MdInfo style={{ marginRight: '8px', verticalAlign: 'middle', color: '#096D6F' }} />
                            Flight itinerary is not available on mobile devices. We use flight arrival time as an alternative.
                        </li>
                        <li style={{ marginBottom: '10px' }}>
                            <MdWarning style={{ marginRight: '8px', verticalAlign: 'middle', color: '#FF6B35' }} />
                            The program is not automatic. You need to manually upload the data.
                        </li>
                    </ul>
                </div>

                <div style={{ marginTop: '30px', textAlign: 'center' }}>
                    <button type="button" onClick={() => navigate('/adminPortal')}>
                        <IoMdArrowBack style={{ marginRight: '8px', verticalAlign: 'middle' }} />
                        Back
                    </button>
                </div>
            </div>
        </div>
    );
}

export default AdminLogin;
